import React from 'react';
import { svgContent } from '../utils/btn-icons-svg-content';

const ButtonSVG = ({ name, title, color }) => {
    const svgColor = color && color !== '' ? color : "#1E4691";
    const svgElement = svgContent[title] || <></>;

    return (
        <div className='btn-inside'>
            <div className="btn-inside-svg">{svgElement}</div>
            <span className='icon-button-label'>{name}</span>
        </div>
    );
};

export default ButtonSVG;
